
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0d4e0196\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./modalImporterTopaze.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalImporterTopaze.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0d4e0196\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalImporterTopaze.vue.html"),
  /* scopeId */
  "data-v-0d4e0196",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modalComponents/modalImporterTopaze/modalImporterTopaze.vue.html
// module id = wdhI
// module chunks = 2